export default __webpack_public_path__ + "static/media/plus-circle.5925d904.svg";